import React from 'react';
import { CArtes } from '../../json/CArtes';
import './cah.css';

const CAH = () => {
  return (
    <div id='cartes_noticias'>
      <div className='row'>
        <div className='col-12'>
          <div className='notice_section'>
            <div className='notice_title'>
                <h3 className='title'>CENTRO DE LAS ARTES DE HIDALGO</h3> 
              <hr className='hr-gob'/>
            </div>
            <div className='notice_content'>
              <div className='col-sm-12'> {}
                <div id="carouselControls" className="carousel slide" data-bs-ride="carousel">
                  <div className="carousel-inner">
                    {CArtes.map((item, index) => (
                      <div key={index} className={index === 0 ? "carousel-item active" : "carousel-item"}>
                        <a href={item.url} target="_blank" rel="noopener noreferrer">
                          <div 
                            className="img-carousel d-block w-100" 
                            style={{ backgroundImage: `url("${item.imagen}")` }}
                          >
                            <div className='title_img_carousel1'>
                              <h6>{item.titulo}</h6>
                              <p>{item.fecha}</p>
                            </div>
                          </div>
                        </a>
                      </div>
                    ))}
                  </div>
                  <button className="carousel-control-prev" type="button" data-bs-target="#carouselControls" data-bs-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Previous</span>
                  </button>
                  <button className="carousel-control-next" type="button" data-bs-target="#carouselControls" data-bs-slide="next">
                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Next</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CAH;